 <ingo-app-shell
    [dataReady]="dataReady"
    [loading]="loading"
    [hasError]="hasError"
    [layout]="layout$ | async"
    [accessBlocked]="accessBlocked$ | async"
    [user]="user$ | async"
    [currentLanguage]="language$ | async"
    [currentRoute]="currentRoute$ | async"
    (onSelectLanguage)="selectLanguage($event)"
    (onLogout)="logOut()"
  >
  </ingo-app-shell>